import React from "react";
import PropTypes from "prop-types";
import { Droppable } from "react-beautiful-dnd";
import { detect } from "detect-browser";
import KanbanCandidateCard from "./KanbanCandidateCard";
import ColumnHeader from "./ColumnHeader";
import {
  Column,
  ListContent,
  ListHeader,
  ListCards,
} from "./styles/column-styles";

const isDropDisabled = (id, isRecruiter) => {
  if (isRecruiter) {
    return id !== "rejected-candidates";
  }
  return id === "submitted-candidates";
};

const KanbanColumn = ({
  id,
  column,
  cards,
  dispatch,
  newCandidatesLink,
  submittedCandidates,
  isRecruiter,
  draggingActive,
  cvLimitFull,
  handleMakeOffer,
  handleJobOffer,
  handleRecruiterConfirmation,
}) => {
  const iOS = detect().name === "ios";

  return (
    <Droppable
      droppableId={id}
      isDropDisabled={isDropDisabled(id, isRecruiter)}
    >
      {(provided, snapshot) => (
        <Column
          draggingActive={draggingActive}
          id={id}
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          <ListContent isDraggingOver={snapshot.isDraggingOver}>
            <ListHeader>
              <ColumnHeader
                id={id}
                title={column.title}
                submittedCandidates={submittedCandidates}
                newCandidatesLink={newCandidatesLink}
                isRecruiter={isRecruiter}
                cvLimitFull={cvLimitFull}
                cardsCount={cards.length}
              />
            </ListHeader>
            <ListCards isDraggingOver={snapshot.isDraggingOver} iOS={iOS}>
              {cards.map((card, index) => (
                <KanbanCandidateCard
                  key={card.id}
                  index={index}
                  id={card.id}
                  card={card}
                  dispatch={dispatch}
                  isRecruiter={isRecruiter}
                  cvLimitFull={cvLimitFull}
                  handleMakeOffer={handleMakeOffer}
                  handleJobOffer={handleJobOffer}
                  handleRecruiterConfirmation={handleRecruiterConfirmation}
                />
              ))}
              {provided.placeholder}
            </ListCards>
          </ListContent>
        </Column>
      )}
    </Droppable>
  );
};

KanbanColumn.propTypes = {
  id: PropTypes.string.isRequired,
  column: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ),
  dispatch: PropTypes.func.isRequired,
  submittedCandidates: PropTypes.string,
  newCandidatesLink: PropTypes.string,
  isRecruiter: PropTypes.bool,
  draggingActive: PropTypes.bool.isRequired,
  cvLimitFull: PropTypes.bool,
  handleMakeOffer: PropTypes.func,
  handleJobOffer: PropTypes.func,
  handleRecruiterConfirmation: PropTypes.func,
};

KanbanColumn.defaultProps = {
  cards: [],
  submittedCandidates: PropTypes.isNull,
  newCandidatesLink: PropTypes.isNull,
  isRecruiter: PropTypes.bool.isNull,
  cvLimitFull: PropTypes.bool.isNull,
  handleMakeOffer: PropTypes.isNull,
  handleJobOffer: PropTypes.isNull,
  handleRecruiterConfirmation: PropTypes.isNull,
};

export default KanbanColumn;
